import { MediaAdapter } from '@core/adapters/media.adapter';
import { Session, SessionAdapter } from './session.model';
import { Branch} from '../branch.model';
import { MediaFile } from '../media-file.model';
import { Adapter } from '@core/adapter';
import { Injectable } from '@angular/core';
import { Student } from '../student.model';
import { SessionModel } from '@core/api/models/course/session.model';
import { BranchModel } from '@core/api/models/branch.model';
import { TeacherModel } from '@core/api/models/teacher.model';


export class Series{
  constructor(
    public id:string,
    public name:string,
    public courseId:string = "",
    public courseName:string = "",
    public sessions:Session[]  = [],
    public classRoom:Student[]  = [],
    public files:MediaFile[] = [],
    public branch:Branch,
    public pricePerPerson:string = "",
    public enrolled:boolean = false,
    public numberOfParticipants:number = 0,
    public maximumParticipants:number = 0,
    public full: boolean = false,
    public openForEnrolments:boolean = true,
    public active: boolean = true,
    public images:MediaFile[] = [],
    public status:'passed'|'failed'|'unresolved' = "unresolved"
  ){}

  public getFiles(){
    return this.files.filter(x => x.type =="file");
  }
  public getAttest(){
    return this.files.filter(x => x.type =="attest");
  }

  public getNextSession(): Session {
    let sessions = this.sessions;
    let currentDate = new Date();
    currentDate.setHours(0,0,0,0);
    const currentTime = currentDate.getTime();
    let nextDate = sessions.find((x:Session) => (new Date(x.date!).getTime() >= currentTime)) || sessions.find(x => x.onDemand && x.wasPresent == null) || sessions[sessions.length-1];
    return nextDate;
  }

  public getCover():string{
    return this.images[0]?this.images[0].path:"";
  }
}

@Injectable({
  providedIn: 'root'
})
export class SeriesAdapter implements Adapter<Series> {

  constructor(private sessionAdapter: SessionAdapter, private mediaAdapter: MediaAdapter) {
  }

  public getBranch(branch: BranchModel|string|undefined): Branch {

    if(typeof(branch) == 'string' || branch == undefined){
      return {id:"0"} as Branch;
    }else{
      return {id:branch.id, name:branch.name, logo: branch.logo} as Branch;
    }
  }

  adapt(item: any): Series {
    let series = new Series(
      item.id,
      item.name,
      item.course? item.course.id:(item.courseId??''),
      item.course? item.course.name:(item.courseName??''),
      item.sessions.map((s:SessionModel) => {
        let session =  this.sessionAdapter.adapt(s);
        if(s.teachers){
          session.teachers = s.teachers.map( (teacher:TeacherModel) => {return {id:teacher.id, salutation:teacher.salutation, firstName:teacher.firstName.trim(), lastName:teacher.lastName.trim(), email:teacher.email??'', description:teacher.description??'', image: teacher.image ? teacher.image.fileObject.fileUrl+'?filter=thumb&width=60&height=60&mode=outbound':''}});
        }
        if(session.name == ""){
          session.name = item.name;
        }
        return session;
      }),
      [],
      // (item.mediaFiles ?? []).map((m: any) => {
      //   let media = this.mediaAdapter.adapt(m);
      //   let addFile:boolean = true;
      //   if(m.session){
      //     media.session = this.sessionAdapter.adapt(item.sessions.find((session:any) => session.id == m.session.split('/').pop()));
      //     addFile = media.session.getFiles().length > 0;
      //   }

      //   return addFile? media : [];
      // }),
      [],
      this.getBranch(undefined),
      item.pricePerPerson,
      item.enrolled || false,
      item.numberOfParticipants??0,
      item.maximumParticipants,
      item.full,
      item.openForEnrolments,
      item.active,
      (item.course?(item.course.mediaFiles??[]):[]).map((m: any)=>{
        return this.mediaAdapter.adapt(m);
      }),
      item.studentStatus
    );
    return series;
  }
}
